export const productCategoryToProductType = {
  V_ISS: 'coupon',
  EC_ISS: 'card',
};

export const getProductType = (productCategory) => {
  if (productCategory !== 'V_ISS' && productCategory !== 'EC_ISS') {
    // eslint-disable-next-line no-console
    console.warn(`getModalType() -> productCategory="${productCategory}" must be valid eagle product_category value = 'V_ISS' || 'EC_ISS'. Returned default value = 'coupon'`);
    return 'coupon';
  }

  return productCategoryToProductType[productCategory];
};
